import { render } from "./AdminGiaoNhanHangHistory.vue?vue&type=template&id=44a5dade&scoped=true"
import script from "./AdminGiaoNhanHangHistory.vue?vue&type=script&lang=js"
export * from "./AdminGiaoNhanHangHistory.vue?vue&type=script&lang=js"

import "./AdminGiaoNhanHangHistory.vue?vue&type=style&index=0&id=44a5dade&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44a5dade"]])

export default __exports__